var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBeka(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F45E20;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25,0C11.2,0,0,11.2,0,25s11.2,25,25,25s25-11.2,25-25S38.8,0,25,0z M25,48C12.3,48,2,37.7,2,25S12.3,2,25,2 s23,10.3,23,23S37.7,48,25,48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.7,34.2L34.7,34.2l-23.7-8.6c-0.4-0.1-0.9-0.1-1.2,0.2c-0.3,0.2-0.4,0.6-0.4,1c0.6,5.8,4.4,10.7,9.9,12.7 c5.5,2,11.5,0.7,15.7-3.4c0.3-0.3,0.4-0.6,0.4-1C35.3,34.7,35.1,34.4,34.7,34.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.1,17.9c-2.9-0.1-5.3,0-6.1,0c-2.8,0-4.7-0.1-5.9-0.1c-1.2-1.1-3.1-2.5-4.5-3.7c-0.6-0.5-1.2-1-4.7-3.9 c-0.4-0.4-0.6-0.6-0.9-0.6c-0.4,0-0.8,0.3-1,0.7c-0.1,0.2-0.1,0.5,0.1,0.7l7.9,6.7l-10.4,0c-0.3,0.1-0.4,0.3-0.5,0.5 c-0.1,0.4,0,0.8,0.3,1.1c0.2,0.2,0.5,0.1,1,0.1c2.9,0.1,5.3,0,6.1,0c2.8,0,4.7,0.1,5.9,0.1c1.2,1.1,3.1,2.5,4.5,3.7 c0.6,0.5,1.2,1,4.7,3.9c0.4,0.4,0.6,0.6,0.9,0.6c0.4,0,0.8-0.3,1-0.7c0.1-0.2,0.1-0.5-0.1-0.7l-7.9-6.7l10.4,0 c0.3-0.1,0.4-0.3,0.5-0.5c0.1-0.4,0-0.8-0.3-1.1C40,17.9,39.7,17.9,39.1,17.9z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeka);
export default __webpack_public_path__ + "static/media/beka.e15d99caa4239e075e3edfc1830d21fd.svg";
export { ForwardRef as ReactComponent };